import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { BeachClubPage } from './pages/BeachClubPage';
import { SUPPage } from './pages/SUPPage';
import { SUPRacePage } from './pages/SUPRacePage';
import { SUPToursPage } from './pages/SUPToursPage';
import { SurfskiPage } from './pages/SurfskiPage';
import { WingFoilPage } from './pages/WingFoilPage';
import { WingFoilCampaignPage } from './pages/WingFoilCampaignPage';
import { EventsPage } from './pages/EventsPage';
import { WaterTribeFestPage } from './pages/WaterTribeFestPage';
import { ThankYouPage } from './pages/ThankYouPage';
import { TranzilaSuccessPage } from './pages/TranzilaSuccessPage';
import { AdminLogin } from './pages/AdminLogin';
import { AdminDashboard } from './pages/AdminDashboard';
import { FloatingJoinButton } from './components/FloatingJoinButton';
import { WorkshopRegistrationPage } from './pages/WorkshopRegistrationPage';
import { AdditionalPaymentPage } from './pages/AdditionalPaymentPage';
import { AdditionalPaymentThankYouPage } from './pages/AdditionalPaymentThankYouPage';
import { ResetRetreatPage } from './pages/ResetRetreatPage';
import { WindMeterPage } from './pages/WindMeterPage';
import { WomensSUPMorningPage } from './pages/WomensSUPMorningPage';
import { SafeSpaceOnWaterPage } from './pages/SafeSpaceOnWaterPage';
function ScrollToTop() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    // Only scroll to top if there's no hash (like #contact)
    if (!hash) {
      // Force immediate scroll
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      // Also use window.scrollTo as backup
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);
    }
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <Router data-id="element-0" data-mp="nv0ybtt2yq5o">
      <ScrollToTop data-id="element-1" data-mp="nvasltl5rjh6" />
      <Routes data-id="element-2" data-mp="nxx05t81tyze">
        <Route path="/" element={<BeachClubPage data-id="element-4" data-mp="stkm7zr8ic0o" />} data-id="element-3" data-mp="sudlkfnv5z8s" />
        <Route path="/sup" element={<SUPPage data-id="element-6" data-mp="swgi7ijiuqmh" />} data-id="element-5" data-mp="sssq8ntq6c9v" />
        <Route path="/sup-race" element={<SUPRacePage data-id="element-8" data-mp="356r32ll9c80" />} data-id="element-7" data-mp="35yp0k2nrm1g" />
        <Route path="/sup-tours" element={<SUPToursPage data-id="element-10" data-mp="3ud1e95yxri91" />} data-id="element-9" data-mp="38kvegdtbvi3" />
        <Route path="/surfski" element={<SurfskiPage data-id="element-12" data-mp="3ucj8niqdvrog" />} data-id="element-11" data-mp="3ubri4mbn8k51" />
        <Route path="/wingfoil" element={<WingFoilPage data-id="element-14" data-mp="d3mlpfjtr3m9" />} data-id="element-13" data-mp="d4nuteha5g1c" />
        <Route path="/wingfoil-campaign" element={<WingFoilCampaignPage data-id="element-16" data-mp="85ui3o9tht28" />} data-id="element-15" data-mp="d45v27vesjoo" />
        <Route path="/events" element={<EventsPage data-id="element-18" data-mp="86cqfj9r7xqi" />} data-id="element-17" data-mp="86mc4unrniqe" />
        <Route path="/water-tribe-fest" element={<WaterTribeFestPage data-id="element-20" data-mp="3gmfuzg5kl6am" />} data-id="element-19" data-mp="3glea6jyr55fp" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-22" data-mp="3bmjs5k8lzkwn" />} data-id="element-21" data-mp="3gja7248ogagh" />
        <Route path="/tranzila-success" element={<TranzilaSuccessPage data-id="element-24" data-mp="3bk720jsp648i" />} data-id="element-23" data-mp="3bncodr9xys0j" />
        <Route path="/admin/login" element={<AdminLogin data-id="element-26" data-mp="3qbzcoihjqu3w" />} data-id="element-25" data-mp="3qbpp11jz4z1d" />
        <Route path="/admin" element={<AdminDashboard data-id="element-28" data-mp="3lkr41oo1jcrs" />} data-id="element-27" data-mp="3qdakcte44m0a" />
        <Route path="/workshop-registration" element={<WorkshopRegistrationPage data-id="element-30" data-mp="2xun1zlqi3l2w" />} data-id="element-29" data-mp="3ljg09ouli50o" />
        <Route path="/additional-payment" element={<AdditionalPaymentPage data-id="element-32" data-mp="2svtm5mnqrhzk" />} data-id="element-31" data-mp="2xtbyzo4vqhcu" />
        <Route path="/additional-payment-thank-you" element={<AdditionalPaymentThankYouPage data-id="element-34" data-mp="18e18lhastiig" />} data-id="element-33" data-mp="2suqyropmnxoe" />
        <Route path="/reset-retreat" element={<ResetRetreatPage data-id="element-36" data-mp="1d4hnz6y6je7g" />} data-id="element-35" data-mp="18c6lbwc21eb7" />
        <Route path="/wind-meter" element={<WindMeterPage data-id="element-38" data-mp="1d5ssxa3d2s05" />} data-id="element-37" data-mp="1d5jbwc0anv6l" />
        <Route path="/womens-sup-morning" element={<WomensSUPMorningPage data-id="element-40" data-mp="ygmx7w3qfjx0" />} data-id="element-39" data-mp="yflk7m35oncn" />
        <Route path="/safe-space-on-water" element={<SafeSpaceOnWaterPage data-id="element-42" data-mp="13e529bempezq" />} data-id="element-41" data-mp="ydik298ahdu7" />
      </Routes>
      <ConditionalFloatingButton data-id="element-43" data-mp="13clopskcxi1n" />
    </Router>;
}
function ConditionalFloatingButton() {
  const location = useLocation();
  // Don't show the general floating button on Water Tribe Fest page, Thank You page, or Tranzila Success page
  if (location.pathname === '/water-tribe-fest' || location.pathname === '/thank-you' || location.pathname === '/tranzila-success' || location.pathname === '/additional-payment' || location.pathname === '/additional-payment-thank-you' || location.pathname === '/reset-retreat' || location.pathname === '/womens-sup-morning' || location.pathname === '/safe-space-on-water' || location.pathname === '/wingfoil-campaign') {
    return null;
  }
  if (location.pathname === '/events') {
    return <FloatingJoinButton label="השאירו פרטים" data-id="element-44" data-mp="m5dxka1o9muw" />;
  }
  return <FloatingJoinButton data-id="element-45" data-mp="h7c5izm9qd7a" />;
}